// Initial Strategy Document  form config

export const isdFields = [
    {
        key: 'matter_details',
        name: 'MATTER DETAILS',
        fields: [
            {
                name: 'client',
                label: 'Client',
                type: 'text',
                validation: {}
            },
            {
                name: 'client_claims_ref_nb',
                label: 'Client Reference',
                type: 'text',
                validation: {},
                disabled: true
            },
            {
                name: 'policyholder',
                label: 'Policyholder',
                type: 'text',
                validation: {}
            },
            {
                name: 'client_handler',
                label: 'Client Handler',
                type: 'text',
                validation: {}
            },
            {
                name: 'client_location',
                label: 'Client Location',
                type: 'text',
                validation: {}
            },
            {
                name: 'lawyer',
                label: 'Lawyer',
                type: 'text',
                validation: {}
            },
            {
                name: 'lawyer_initials',
                label: 'Lawyer Initials',
                type: 'text',
                validation: {}
            },
            {
                name: 'dacb_reference',
                label: 'Reference',
                type: 'text',
                validation: {}
            },
            {
                name: 'matter',
                label: 'Matter',
                type: 'text',
                validation: {}
            },
            {
                name: 'current_date',
                label: 'Date',
                type: 'date',
                validation: {}
            },
            {
                name: 'claimant_representative',
                label: 'Claimant\'s Representative',
                type: 'text',
                validation: {}
            },
        ]
    },
    {
        key: 'procedural_position',
        name: 'PROCEDURAL POSITION',
        fields: [
            {
                name: 'date_of_issue',
                label: 'Date of issue',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_of_service',
                label: 'Date of service',
                type: 'date',
                validation: {}
            },
            {
                name: 'defence_due_date',
                label: 'Defence Due Date',
                type: 'date',
                validation: {}
            }
        ]
    },
    {
        key: 'claim_ever_been_in_portal',
        name: 'CLAIM EVER BEEN IN A PORTAL',
        fields: [
            {
                name: 'moj',
                label: 'MOJ',
                type: 'boolean',
                validation: {}
            },
            {
                name: 'moj_position_application_considerations',
                label: 'MOJ Position/Part 7 Application Considerations',
                type: 'text',
                validation: {}
            },
            {
                name: 'directions_quantum',
                label: 'Directions/Quantum',
                type: 'boolean',
                validation: {}
            },
            {
                name: 'other_interims_applications',
                label: 'Other/Interims/Applications',
                type: 'boolean',
                validation: {}
            },
            {
                name: 'liability',
                label: 'Liability',
                type: 'boolean',
                validation: {}
            },
            {
                name: 'oic_position',
                label: 'OIC Position',
                type: 'text',
                validation: {}
            },
        ]
    },
    {
        key: 'frc_track_band_considerations',
        name: 'FRC (TRACK & BAND) CONSIDERATIONS (DELETE IF SMALL CLAIMS CASE)',
        can_be_disabled: true,
        fields: [
            {
                name: 'fast',
                label: 'Fast',
                type: 'boolean',
                validation: {}
            },
            {
                name: 'intermediate',
                label: 'Intermediate',
                type: 'boolean',
                validation: {}
            },
            {
                name: 'multi_no_band_needed',
                label: 'Multi (no band needed)',
                type: 'boolean',
                validation: {}
            },
            {
                name: 'band_1',
                label: 'Band 1',
                type: 'boolean',
                validation: {}
            },
            {
                name: 'band_2',
                label: 'Band 2',
                type: 'boolean',
                validation: {}
            },
            {
                name: 'band_3',
                label: 'Band 3*',
                type: 'boolean',
                validation: {}
            },
            {
                name: 'band_4',
                label: 'Band 4*',
                type: 'boolean',
                validation: {}
            },
        ]
    },
    {
        key: 'indemnity',
        name: 'INDEMNITY',
        fields: [
            {
                name: 'indemnity_status_defendant',
                label: 'Indemnity Status - Defendant',
                type: 'boolean',
                validation: {}
            },
        ]
    },
    {
        key: 'liability',
        name: 'LIABILITY (DELETE IF QUANTUM ONLY CASE)',
        can_be_disabled: true,
        fields: [
            {
                name: 'admited_or_disputed',
                label: 'Admitted / Disputed?',
                type: 'text',
                validation: {}
            },
            {
                name: 'claimant_case',
                label: 'Claimant’s case',
                type: 'text',
                validation: {}
            },
            {
                name: 'defendant_case',
                label: 'Defendant’s case',
                type: 'text',
                validation: {}
            },
            {
                name: 'case_law_highway_code',
                label: 'Case law/Highway code',
                type: 'text',
                validation: {}
            },
            {
                name: 'further_investigation',
                label: 'Further investigation',
                type: 'text',
                validation: {}
            },
        ]
    },
    {
        key: 'counterclaim',
        name: 'COUNTERCLAIM (DELETE IF QUANTUM ONLY CASE)',
        can_be_disabled: true,
        fields: [
            {
                name: 'insurer_outlay_recovered',
                label: 'Insurer outlay to be recovered',
                type: 'boolean',
                validation: {}
            },
            {
                name: 'memorandum_of_understanding',
                label: 'Memorandum of Understanding agreed',
                type: 'boolean',
                validation: {}
            },
            {
                name: 'insured_uninsured_losses',
                label: 'Insured\'s uninsured losses to be recovered',
                type: 'boolean',
                validation: {}
            },
            {
                name: 'details_of_insured',
                label: 'Details of Insured\'s counterclaim',
                type: 'text',
                validation: {}
            },
            {
                name: 'funding',
                label: 'Funding',
                type: 'text',
                validation: {}
            },
        ]
    },
    {
        key: 'pre_issue_offers_interim_payments',
        name: 'PRE-ISSUE OFFERS / INTERIM PAYMENTS',
        fields: [
            {
                name: 'liability_offer_amount',
                label: 'Liability offer amount',
                type: 'float',
                validation: {}
            },
            {
                name: 'liability_offer_date',
                label: 'Liability offer date',
                type: 'date',
                validation: {}
            },
            {
                name: 'quantum_offer_date_1',
                label: 'Quantum offer date (1)',
                type: 'date',
                validation: {}
            },
            {
                name: 'quantum_offer_amount_1',
                label: 'Quantum offer amount (1)',
                type: 'float',
                validation: {}
            },
            {
                name: 'quantum_offer_date_2',
                label: 'Quantum offer date (2)',
                type: 'date',
                validation: {}
            },
            {
                name: 'quantum_offer_amount_2',
                label: 'Quantum offer amount (2)',
                type: 'float',
                validation: {}
            },
            {
                name: 'quantum_offer_date_3',
                label: 'Quantum offer date (3)',
                type: 'date',
                validation: {}
            },
            {
                name: 'quantum_offer_amount_3',
                label: 'Quantum offer amount (3)',
                type: 'float',
                validation: {}
            },
            {
                name: 'quantum_offer_date_4',
                label: 'Quantum offer date (4)',
                type: 'date',
                validation: {}
            },
            {
                name: 'quantum_offer_amount_4',
                label: 'Quantum offer amount (4)',
                type: 'float',
                validation: {}
            },
            {
                name: 'pre_issue_payment_amount_vehicle_damages',
                label: 'Pre-issue payment amount vehicle damages',
                type: 'float',
                validation: {}
            },
            {
                name: 'pre_issue_payment_date_vehicle_damages',
                label: 'Pre-issue payment date vehicle damages',
                type: 'date',
                validation: {}
            },
            {
                name: 'pre_issue_payment_amount_vehicle_storage',
                label: 'Pre-issue payment amount vehicle storage',
                type: 'float',
                validation: {}
            },
            {
                name: 'pre_issue_payment_date_vehicle_storage',
                label: 'Pre-issue payment date vehicle storage',
                type: 'date',
                validation: {}
            },
        ]
    },
    {
        key: 'quantum_credit_hire',
        name: 'QUANTUM - CREDIT HIRE',
        fields: [
            {
                name: 'hire_company',
                label: 'Hire Company',
                type: 'dropdown',
                dropdownOptionsAPI: 'chos',
                validation: {},
                disabled: true,
            },
            {
                name: 'number_of_days_claimed',
                label: 'Number of Days Claimed',
                type: 'integer',
                validation: {},
                disabled: true,
            },
            {
                name: 'hire_ongoing',
                label: 'Hire Ongoing?',
                type: 'boolean',
                validation: {},
            },
            {
                name: 'gra_pre_lit_daily_amount',
                label: 'GTA Pre-Lit Daily Amount',
                type: 'float',
                validation: {},
            },
            {
                name: 'litigated_daily_rate',
                label: 'Non GTA / Litigated Daily Rate and total',
                type: 'float',
                validation: {},
            },
            {
                name: 'rate_and_total',
                label: 'Rate and Total',
                type: 'float',
                validation: {},
            },
            {
                name: 'cdw',
                label: 'CDW',
                type: 'float',
                validation: {},
            },
            {
                name: 'auto',
                label: 'Auto',
                type: 'float',
                validation: {},
            },
            {
                name: 'other',
                label: 'Other',
                type: 'float',
                validation: {},
            },
            {
                name: 'additional_driver',
                label: 'Additional Driver',
                type: 'float',
                validation: {},
            },
            {
                name: 'sat_nav',
                label: 'Sat Nav',
                type: 'float',
                validation: {},
            },
            {
                name: 'at_risk',
                label: 'At Risk (underage, endorsements etc.)',
                type: 'float',
                validation: {},
            },
            {
                name: 'windscreen_tyres_underbody',
                label: 'Windscreen, Tyres, Underbody',
                type: 'float',
                validation: {},
            },
            {
                name: 'own_insurance_excess',
                label: 'Own Insurance Excess',
                type: 'float',
                validation: {},
            },
            {
                name: 'basic_excess',
                label: 'Basic Excess',
                type: 'float',
                validation: {},
            },
            {
                name: 'residual_excess',
                label: 'Residual Excess',
                type: 'float',
                validation: {},
            },
            {
                name: 'theft_excess',
                label: 'Theft Excess',
                type: 'float',
                validation: {},
            },
            {
                name: 'delivery_and_collection',
                label: 'Delivery and Collection',
                type: 'float',
                validation: {},
            },
            {
                name: 'other_one_off',
                label: 'Other (one off) value',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_hire_claimed_ngta_or_abi_gta_commercial_rate',
                label: 'Total Hire Claimed (NGTA or ABI GTA Commercial Rate)',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_hire_claimed_vat_ngta_or_abi_gta_commercial_rate',
                label: 'Total Hire Claimed VAT (NGTA or ABI GTA Commercial Rate)',
                type: 'float',
                validation: {},
            },
            {
                name: 'claimant_occupation',
                label: 'Claimant’s Occupation',
                type: 'text',
                validation: {},
            },
            {
                name: 'claimant_vehicle_make',
                label: 'Claimant’s vehicle make',
                type: 'text',
                validation: {},
            },
            {
                name: 'claimant_vehicle_model',
                label: 'Claimant’s vehicle model',
                type: 'text',
                validation: {},
            },
            {
                name: 'claimant_vehicle_vrn',
                label: 'Claimant’s vehicle VRN',
                type: 'text',
                validation: {},
            },
            {
                name: 'claimant_vehicle_abi_gta_group',
                label: 'Claimant’s vehicle ABI GTA Group',
                type: 'text',
                validation: {},
            },
            {
                name: 'hire_vehicle_make_1',
                label: 'Hire vehicle make (1)',
                type: 'text',
                validation: {},
            },
            {
                name: 'hire_vehicle_model_1',
                label: 'Hire vehicle model (1)',
                type: 'text',
                validation: {},
            },
            {
                name: 'hire_vehicle_vrn_1',
                label: 'Hire vehicle VRN (1)',
                type: 'text',
                validation: {},
            },
            {
                name: 'hire_vehicle_abi_gta_group_1',
                label: 'Hire vehicle ABI GTA Group (1)',
                type: 'text',
                validation: {},
            },
            {
                name: 'hire_vehicle_make_2',
                label: 'Hire vehicle make (2)',
                type: 'text',
                validation: {},
            },
            {
                name: 'hire_vehicle_model_2',
                label: 'Hire vehicle model (2)',
                type: 'text',
                validation: {},
            },
            {
                name: 'hire_vehicle_vrn_2',
                label: 'Hire vehicle VRN (2)',
                type: 'text',
                validation: {},
            },
            {
                name: 'hire_vehicle_abi_gta_group_2',
                label: 'Hire vehicle ABI GTA Group (2)',
                type: 'text',
                validation: {},
            },
            {
                name: 'hire_vehicle_make_3',
                label: 'Hire vehicle make (3)',
                type: 'text',
                validation: {},
            },
            {
                name: 'hire_vehicle_model_3',
                label: 'Hire vehicle model (3)',
                type: 'text',
                validation: {},
            },
            {
                name: 'hire_vehicle_vrn_3',
                label: 'Hire vehicle VRN (3)',
                type: 'text',
                validation: {},
            },
            {
                name: 'hire_vehicle_abi_gta_group_3',
                label: 'Hire vehicle ABI GTA Group (3)',
                type: 'text',
                validation: {},
            },
            {
                name: 'hire_vehicle_make_4',
                label: 'Hire vehicle make (4)',
                type: 'text',
                validation: {},
            },
            {
                name: 'hire_vehicle_model_4',
                label: 'Hire vehicle model (4)',
                type: 'text',
                validation: {},
            },
            {
                name: 'hire_vehicle_vrn_4',
                label: 'Hire vehicle VRN (4)',
                type: 'text',
                validation: {},
            },
            {
                name: 'hire_vehicle_abi_gta_group_4',
                label: 'Hire vehicle ABI GTA Group (4)',
                type: 'text',
                validation: {},
            },
            {
                name: 'hire_start_date_1',
                label: 'Hire Start Date (1)',
                type: 'date',
                validation: [{name: 'required'}],
                modalValidation: [{
                    name: 'dateSameOrBefore',
                    params: {matchFieldName: 'hire_end_date_1'}
                }]
            },
            {
                name: 'hire_end_date_1',
                label: 'Hire End Date (1)',
                type: 'date',
                validation: {}
            },
            {
                name: 'hire_start_date_2',
                label: 'Hire Start Date (2)',
                type: 'date',
                validation: {},
                modalValidation: [{
                    name: 'dateSameOrBefore',
                    params: {matchFieldName: 'hire_end_date_2'}
                }]
            },
            {
                name: 'hire_end_date_2',
                label: 'Hire End Date (2)',
                type: 'date',
                validation: {}
            },
            {
                name: 'hire_start_date_3',
                label: 'Hire Start Date (3)',
                type: 'date',
                validation: {},
                modalValidation: [{
                    name: 'dateSameOrBefore',
                    params: {matchFieldName: 'hire_end_date_3'}
                }]
            },
            {
                name: 'hire_end_date_3',
                label: 'Hire End Date (3)',
                type: 'date',
                validation: {}
            },
            {
                name: 'hire_start_date_4',
                label: 'Hire Start Date (4)',
                type: 'date',
                validation: {},
                modalValidation: [{
                    name: 'dateSameOrBefore',
                    params: {matchFieldName: 'hire_end_date_4'}
                }]
            },
            {
                name: 'hire_end_date_4',
                label: 'Hire End Date (4)',
                type: 'date',
                validation: {}
            },
            {
                name: 'accident_date',
                label: 'Date of Accident',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_liability_admitted',
                label: 'Date Liability Admitted',
                type: 'date',
                validation: {}
            },
            {
                name: 'intervention_date',
                label: 'Date of Intervention Letter',
                type: 'date',
                validation: {}
            },
            {
                name: 'inspection_date',
                label: 'Engineer inspection',
                type: 'date',
                validation: {}
            },
            {
                name: 'engineer_report_sent_off',
                label: 'Date engineer\'s report sent to client',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_engineer_report_received_by_client',
                label: 'Date engineer\'s report received by client',
                type: 'date',
                validation: {}
            },
            {
                name: 'repairs_authorised_offer_made',
                label: 'Repairs authorised/total loss offer made',
                type: 'float',
                validation: {}
            },
            {
                name: 'date_repairs_started',
                label: 'Date Repairs Started',
                type: 'date',
                validation: {}
            },
            {
                name: 'total_loss_offer_accepted',
                label: 'Total Loss Offer Accepted',
                type: 'float',
                validation: {}
            },
            {
                name: 'date_repairs_completed',
                label: 'Date Repairs Completed',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_satisfaction_note_signed',
                label: 'Date Satisfaction Note Signed',
                type: 'date',
                validation: {}
            },
            {
                name: 'pav_paid',
                label: 'PAV Paid',
                type: 'float',
                validation: {}
            },
            {
                name: 'pav_received',
                label: 'PAV Received',
                type: 'date',
                validation: {}
            },
            {
                name: 'hire_finished',
                label: 'Hire finished',
                type: 'date',
                validation: {}
            },
            {
                name: 'duration_arguments',
                label: 'Duration arguments',
                type: 'textarea',
                validation: {}
            },
            {
                name: 'date_agreement_signed',
                label: 'Date agreement signed',
                type: 'date',
                validation: {}
            },
            {
                name: 'need_vehicle_hired',
                label: 'Need/Vehicle hired',
                type: 'textarea',
                validation: {}
            },
            {
                name: 'impecuniosity',
                label: 'Impecuniosity',
                type: 'textarea',
                validation: {}
            },
            {
                name: 'intervention',
                label: 'Intervention',
                type: 'text',
                validation: {}
            },
            {
                name: 'intervention_rate',
                label: 'Intervention Rate',
                type: 'float',
                validation: {}
            },
            {
                name: 'other_missing_info_docs',
                label: 'OTHER/ MISSING INFO. & DOCS',
                type: 'textarea',
                validation: {}
            },
            {
                name: 'basic_hire_rate_provider_1',
                label: 'Basic Hire Rate Provider (1)',
                type: 'text',
                validation: {}
            },
            {
                name: 'basic_hire_rate_total_daily_rate_1',
                label: 'Basic Hire Rate Total Daily Rate (1)',
                type: 'float',
                validation: {}
            },
            {
                name: 'basic_hire_rate_provider_2',
                label: 'Basic Hire Rate Provider (2)',
                type: 'text',
                validation: {}
            },
            {
                name: 'basic_hire_rate_total_daily_rate_2',
                label: 'Basic Hire Rate Total Daily Rate (2)',
                type: 'float',
                validation: {}
            },
            {
                name: 'basic_hire_rate_provider_3',
                label: 'Basic Hire Rate Provider (3)',
                type: 'text',
                validation: {}
            },
            {
                name: 'basic_hire_rate_total_daily_rate_3',
                label: 'Basic Hire Rate Total Daily Rate (3)',
                type: 'float',
                validation: {}
            },
        ]
    },
    {
        key: 'quantum_special_damages',
        name: 'Quantum - Special Damages',
        fields: [
            {
                name: 'quantum_vehicle_damage',
                label: 'Vehicle Damage',
                type: 'float',
                validation: {}
            },
            {
                name: 'quantum_vehicle_damage_offer',
                label: 'Vehicle Damage Offer',
                type: 'textarea',
                validation: {}
            },
            {
                name: 'quantum_recovery',
                label: 'Recovery',
                type: 'float',
                validation: {}
            },
            {
                name: 'quantum_recovery_offer',
                label: 'Recovery Offer',
                type: 'textarea',
                validation: {}
            },
            {
                name: 'quantum_storage',
                label: 'Storage',
                type: 'float',
                validation: {}
            },
            {
                name: 'quantum_storage_offer',
                label: 'Storage Offer',
                type: 'textarea',
                validation: {}
            },
            {
                name: 'quantum_uninsured',
                label: 'Uninsured',
                type: 'float',
                validation: {}
            },
            {
                name: 'quantum_uninsured_offer',
                label: 'Uninsured Offer',
                type: 'textarea',
                validation: {}
            }
        ]
    },
    {
        key: 'personal_injury',
        name: 'PERSONAL INJURY (DO NOT SHOW THIS SECTION IF NO PI)',
        can_be_disabled: true,
        fields: [
            {
                name: 'diagnosis',
                label: 'Diagnosis',
                type: 'text',
                validation: {}
            },
            {
                name: 'prognosis',
                label: 'Prognosis',
                type: 'text',
                validation: {}
            },
            {
                name: 'coa_case_law',
                label: 'COA/case law',
                type: 'text',
                validation: {}
            },
            {
                name: 'valuation_bracket',
                label: 'Valuation Bracket',
                type: 'text',
                validation: {}
            },
            {
                name: 'cru_nhs',
                label: 'CRU / NHS',
                type: 'float',
                validation: {}
            }
        ]
    },
    {
        key: 'damages_reserves',
        name: 'DAMAGES RESERVES',
        fields: [
            {
                name: 'general_damages',
                label: 'General Damages',
                type: 'float',
                validation: {}
            },
            {
                name: 'credit_hire',
                label: 'Credit Hire',
                type: 'float',
                validation: {}
            },
            {
                name: 'special_damages_total',
                label: 'Special Damages Total',
                type: 'float',
                validation: {}
            },
        ]
    },
    {
        key: 'costs_reserves',
        name: 'COSTS RESERVES',
        fields: [
            {
                name: 'reserve_claimant_costs',
                label: 'Reserve for Claimant costs',
                type: 'float',
                validation: {}
            },
            {
                name: 'reserve_claimant_costs_total',
                label: 'Reserve for Claimant costs total',
                type: 'float',
                validation: {}
            },
            {
                name: 'reserve_claimant_vat_fees',
                label: 'VAT on C\'s Fees',
                type: 'float',
                validation: {}
            },
            {
                name: 'reserve_claimant_vat_disbs',
                label: 'VAT on C\'s Disbs',
                type: 'float',
                validation: {}
            },
            {
                name: 'reserve_defence_costs',
                label: 'Reserve for Defence costs',
                type: 'float',
                validation: {}
            },
            {
                name: 'reserve_defence_costs_total',
                label: 'Reserve for Defence costs total',
                type: 'float',
                validation: {}
            },

            {
                name: 'reserve_defence_vat_fees',
                label: 'VAT on Our Fees',
                type: 'float',
                validation: {}
            },
            {
                name: 'reserve_defence_vat_disbs',
                label: 'VAT on Our Disbs',
                type: 'float',
                validation: {}
            },
        ]
    },
    {
        key: 'proposed_offer_credit_hire_brackets',
        name: 'PROPOSED OFFER CREDIT HIRE BRACKETS',
        fields: [
            {
                name: 'requested_total_hire_period',
                label: 'Requested Total Hire Period',
                type: 'integer',
                validation: {}
            },
            {
                name: 'requested_hire_daily_rate',
                label: 'Requested Hire Daily Rate',
                type: 'float',
                validation: {}
            },
            {
                name: 'requested_total',
                label: 'Requested Total',
                type: 'float',
                validation: {}
            },
            {
                name: 'response_total_hire_period',
                label: 'Response Total Hire Period',
                type: 'integer',
                validation: {}
            },
            {
                name: 'response_hire_daily_rate',
                label: 'Response Hire Daily Rate',
                type: 'float',
                validation: {}
            },
            {
                name: 'response_total',
                label: 'Response Total',
                type: 'float',
                validation: {}
            },
            {
                name: 'savings_total_hire_period',
                label: 'Savings Total Hire Period',
                type: 'integer',
                validation: {}
            },
            {
                name: 'savings_hire_daily_rate',
                label: 'Savings Hire Daily Rate',
                type: 'float',
                validation: {}
            },
            {
                name: 'savings_total',
                label: 'Savings Total',
                type: 'float',
                validation: {}
            },
            {
                name: 'gta_response_total_hire_period',
                label: 'GTA Response Total Hire Period',
                type: 'integer',
                validation: {}
            },
            {
                name: 'gta_response_hire_daily_rate',
                label: 'GTA Response Hire Daily Rate',
                type: 'float',
                validation: {}
            },
            {
                name: 'gta_response_total',
                label: 'GTA Response Total',
                type: 'float',
                validation: {}
            },
        ]
    },
    {
        key: 'proposed_offer_brackets',
        name: 'PROPOSED OFFER BRACKETS',
        fields: [
            {
                name: 'proposed_offer_brackets',
                label: 'Proposed Offer Brackets',
                type: 'textarea',
                validation: {}
            }
        ]
    },
    {
        key: 'strategy',
        name: 'STRATEGY',
        fields: [
            {
                name: 'strategy_actions',
                label: 'Strategy Action',
                type: 'textarea',
                validation: {}
            }
        ]
    },
    {
        key: 'cited_case_law',
        name: 'Cited Case Law',
        fields: [
            {
                name: 'cited_case_law',
                label: 'Case Law',
                type: 'textarea',
                validation: {}
            }
        ]
    },
    {
        key: 'supervision',
        name: 'SUPERVISION',
        fields: [
            {
                name: 'supervisor_comments',
                label: 'Supervisor’s comments',
                type: 'textarea',
                validation: {}
            },
            {
                name: 'mi_checked',
                label: 'MI checked',
                type: 'boolean',
                validation: {}
            },
            {
                name: 'signed_and_dated',
                label: 'Signed and dated',
                type: 'boolean',
                validation: {}
            },
        ]
    },
];
